import { protobufTransact } from "./ProtobufCommand";
import { Command, DataWithAddr, DiagnosticCommand, ModuleData, OffsetSize, Request, ServiceRoutine, SetTestMode, WssConfig } from "./generated/wss_pb";

export const identify = async (port: SerialPort, onDisconnect: (reason: string) => void) => {
    const req = new Request();
    req.setIdentify(new Command());

    return protobufTransact(port, req, onDisconnect);
};

export const rebootToBootloader = async (port: SerialPort, onDisconnect: (reason: string) => void) => {
    const req = new Request();
    req.setRebootloader(new Command());

    return protobufTransact(port, req, onDisconnect);
};

export const doEspPassthrough = async (port: SerialPort, onDisconnect: (reason: string) => void) => {
    const req = new Request();
    req.setDoesppassthrough(new Command());

    return protobufTransact(port, req, onDisconnect);
};

export const erase = async (port: SerialPort, onDisconnect: (reason: string) => void, offset: number, size: number) => {
    const eraseReq = new Request();
    eraseReq.setErase(new OffsetSize());
    eraseReq.getErase()?.setOffset(offset);
    eraseReq.getErase()?.setSize(size);

    return protobufTransact(port, eraseReq, onDisconnect, 2000);
};

export const write = async (port: SerialPort, onDisconnect: (reason: string) => void, offset: number, data: Uint8Array) => {
    const writeReq = new Request();
    writeReq.setWrite(new DataWithAddr());
    writeReq.getWrite()?.setData(data);
    writeReq.getWrite()?.setOffset(offset);

    return protobufTransact(port, writeReq, onDisconnect);
};

export const getConfig = async (port: SerialPort, onDisconnect: (reason: string) => void) => {
    const configRequest = new Request();
    configRequest.setGetconfig(new Command());

    return protobufTransact(port, configRequest, onDisconnect);
}

export const setConfig = async (port: SerialPort, onDisconnect: (reason: string) => void, config: WssConfig) => {
    const configRequest = new Request();
    configRequest.setSetconfig(config);

    return protobufTransact(port, configRequest, onDisconnect);
}

export const getStatus = async (port: SerialPort, onDisconnect: (reason: string) => void) => {
    const configRequest = new Request();
    configRequest.setGetstatus(new Command());

    return protobufTransact(port, configRequest, onDisconnect);
}

export const setTestMode = async (port: SerialPort, onDisconnect: (reason: string) => void, testModeParams: SetTestMode) => {
    const configRequest = new Request();
    configRequest.setSettestmode(testModeParams);

    return protobufTransact(port, configRequest, onDisconnect);
}

export const exitTestMode = async (port: SerialPort, onDisconnect: (reason: string) => void) => {
    const configRequest = new Request();
    configRequest.setExittestmode(new Command());

    return protobufTransact(port, configRequest, onDisconnect);
}

export const runSelfTest = async (port: SerialPort, onDisconnect: (reason: string) => void) => {
    const configRequest = new Request();
    configRequest.setRunselftest(new Command());

    return protobufTransact(port, configRequest, onDisconnect);
}

export const readDtcs = async (port: SerialPort, onDisconnect: (reason: string) => void) => {
    const dtcRequest = new Request();
    dtcRequest.setDiagnostic(new DiagnosticCommand().setReaddtc(new Command()));

    return protobufTransact(port, dtcRequest, onDisconnect);
}

export const clearDtcs = async (port: SerialPort, onDisconnect: (reason: string) => void) => {
    const dtcRequest = new Request();
    dtcRequest.setDiagnostic(new DiagnosticCommand().setCleardtc(new Command()));

    return protobufTransact(port, dtcRequest, onDisconnect);
}

export const readCodingData = async (port: SerialPort, onDisconnect: (reason: string) => void) => {
    const request = new Request();
    request.setDiagnostic(new DiagnosticCommand().setReadcodingdata(new Command()));

    return protobufTransact(port, request, onDisconnect);
}

export const writeCodingData = async (port: SerialPort, onDisconnect: (why: any) => void, codingData: Uint8Array) => {
    const request = new Request();
    const data = new ModuleData().setData(codingData);
    request.setDiagnostic(new DiagnosticCommand().setWritecodingdata(data));

    return protobufTransact(port, request, onDisconnect);
}

export const readIdentData = async (port: SerialPort, onDisconnect: (reason: string) => void) => {
    const dtcRequest = new Request();
    dtcRequest.setDiagnostic(new DiagnosticCommand().setReadident(new Command()));

    return protobufTransact(port, dtcRequest, onDisconnect);
}

export const startRoutine = async (port: SerialPort, onDisconnect: (reason: string) => void, routineId: number) => {
    const request = new Request();
    const routine = new ServiceRoutine().setRoutineid(routineId);
    request.setDiagnostic(new DiagnosticCommand().setStartroutine(routine));

    // Longer timeout: this reads ident, opens the diag session, waits, and starts the routine
    return protobufTransact(port, request, onDisconnect, 20000);
}

export const routineResults = async (port: SerialPort, onDisconnect: (reason: string) => void, routineId: number) => {
    const request = new Request();
    const routine = new ServiceRoutine().setRoutineid(routineId);
    request.setDiagnostic(new DiagnosticCommand().setRoutineresults(routine));

    return protobufTransact(port, request, onDisconnect);
}

export const testerPresent = async (port: SerialPort, onDisconnect: (reason: string) => void) => {
    const request = new Request();
    request.setDiagnostic(new DiagnosticCommand().setTesterpresent(new Command()));

    return protobufTransact(port, request, onDisconnect);
}

export const stopDiagSession = async (port: SerialPort, onDisconnect: (reason: string) => void) => {
    const request = new Request();
    request.setDiagnostic(new DiagnosticCommand().setStopdiagsession(new Command()));

    return protobufTransact(port, request, onDisconnect);
}
